<div class="panel panel-default">
  <div class="panel-heading flex flex--space-between">
    <h4 class="margin-top-0 margin-bottom-0 flex">
      <i class="icon margin-right-8">edit</i>{{ appCopy.panelHeader['notesTitle'+selectedLanguage] }}
    </h4>
    <a class="link pull-right" href="javascript:void(0)" (click)="toggleAddNoteSection()">
      {{ !showAddNote ? appCopy.panelHeader['addNoteText'+selectedLanguage] : appCopy.panelHeader['hideText'+selectedLanguage] }}
    </a>
  </div>
  <div class="panel-body" *ngIf="!bookingDetailsAdminLoaded">
    <div class="loader-container">
      <div class="loader">
        <svg class="circular" viewBox="25 25 50 50">
          <circle class="path" cx="50" cy="50" r="20" />
        </svg>
      </div>
    </div>
  </div>
  <div class="panel-body" *ngIf="bookingDetailsAdminLoaded">
    <form *ngIf="showAddNote"
      #formAddNote="ngForm"
      class="margin-bottom-16"
      name="formAddNote"
      (submit)="handleNoteSubmit(formAddNote.value, $event)"
      novalidate>
      <textarea class="form-control form-control--no-label margin-bottom-12"
                id="addNote"
                name="addNote"
                placeholder="{{ appCopy.panelHeader['enterNotePlaceholder'+selectedLanguage] }}"
                rows="7"
                ngModel
                required>
      </textarea>
      <button type="submit" class="btn btn-accent btn-block" [disabled]="formAddNote.invalid || showAddNoteLoader">
        <div class="loader-container-btn" *ngIf="showAddNoteLoader">
          <div class="loader loader--white">
            <svg class="circular" viewBox="25 25 50 50">
              <circle class="path" cx="50" cy="50" r="20" />
            </svg>
          </div>
        </div>
        {{ appCopy.panelHeader['addButton'+selectedLanguage] }}
      </button>
    </form>
    <div *ngIf="noBookingNotes">
      <p>{{ appCopy.panelHeader['noBookingNotesText'+selectedLanguage] }}</p>
    </div>
    <div *ngIf="!noBookingNotes">
      <div *ngFor="let note of noteUserArray; let last = last">
        <div class="note-item">
          <p class="margin-bottom-8"><strong [innerHTML]="note.text"></strong></p>
          <p class="margin-bottom-0 clearfix">
            <span class="text-caption text-muted-light pull-left">{{ note.firstName }} {{ note.lastName }}<br>{{ note.userRoles }}</span>
            <span class="text-caption text-muted-light pull-right">
              {{ note.date | amDateFormat: 'DD.MM.YY' }} | {{ note.date | amDateFormat: 'HH:mm' }}
            </span>
          </p>
        </div>
        <hr class="margin-top-16 margin-bottom-16" *ngIf="!last">
      </div>
    </div>
  </div>
</div>